"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Space;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["flex", "width", "height", "style"];
function Space(props) {
  var flex = props.flex,
    width = props.width,
    height = props.height,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var actualFlex = flex === undefined ? _reactNative.Platform.OS == "android" ? 0 : false : flex;
  var spaceStyles = [styles["default"], {
    flex: actualFlex === true ? 1 : actualFlex,
    width: width,
    height: height
  }, style];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: spaceStyles
  }, rest));
}
Space.ColumnBreak = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    height: 24
  }, props));
};
Space.ColumnSemiBreak = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    height: 12
  }, props));
};
Space.ColumnGap = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    height: 8
  }, props));
};
Space.RowBreak = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    width: 24
  }, props));
};
Space.RowSemiBreak = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    width: 12
  }, props));
};
Space.RowGap = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Space, (0, _extends2["default"])({
    width: 8
  }, props));
};
Space.propTypes = {
  flex: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  style: _propTypes["default"].object
};
var styles = _reactNative.StyleSheet.create({
  "default": {
    flex: 0
  }
});